<template>
  <section v-if="error">
    <br />
    <p class="error">{{ error }}</p>
  </section>

  <section
    v-if="loaded"
    class="page-container grid-container"
  >
    <div class="grid-container">
      <section>
        <div class="grid-x grid-margin-x">
          <div class="cell small-12">
            <a @click="router.back()">← Back</a>
          </div>
        </div>
      </section>

      <section>
        <div class="grid-x grid-margin-x">
          <div class="cell small-12">
            <h1 class="text-2xl font-bold">
              Add New Intermediary Client
            </h1>

            <p>
              To create a new intermediary client, please select the
              intermediary you wish to link the client to and choose
              'Start Wizard'.
            </p>

            <label for="intermediary">Intermediary</label>

            <IntermediaryAutoSuggest
              v-model="intermediarySearchText"
              v-model:selected-intermediary-id="selectedIntermediaryId"
              :intermediaries="intermediaries"
              label-field="name"
              value-field="intermediaryId"
              name="intermediary"
            />

            <p
              v-if="intermediarySearchText && !selectedIntermediaryId"
              class="help-text"
            >
              Please select an intermediary from the suggestions.
            </p>

            <br />

            <button
              class="btn btn-primary"
              :disabled="!selectedIntermediaryId"
              @click="startWizard"
            >
              Start Wizard
            </button>

            <button
              class="btn btn-secondary"
              @click="router.push({ name: 'AdminClientList' })"
            >
              Return to Clients
            </button>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getIntermediaries } from '@/services/implementationmanagement.api'

import IntermediaryAutoSuggest from '@/components/IntermediaryAutoSuggest.vue'

const router = useRouter()

const error = ref('')
const loaded = ref(true)

const intermediaries = ref([])
const intermediarySearchText = ref('')
const selectedIntermediaryId = ref(null)

const startWizard = () => {
  error.value = ''

  if (!selectedIntermediaryId.value) {
    error.value =
      'Please select a valid intermediary from the predictive results before starting the wizard.'
    return
  }

  router.push({
    name: 'AddNewClientWithIntermediary',
    params: {
      intermediaryId: selectedIntermediaryId.value
    }
  })
}

onMounted(async () => {
  try {
    const response = await getIntermediaries()
    intermediaries.value = response.data
  } catch (fetchError) {
    console.error('Error fetching intermediaries:', fetchError)
    error.value = 'Unable to load intermediaries.'
  }
})
</script>

<style>
.help-text {
  color: #ff0000;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}
</style>